import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ChangePasswordByPasswordDialogComponent } from '../../change-password/change-password-by-password.dialog/change-password-by-password.dialog.component';

@Component({
  selector: 'app-security-menu',
  styleUrls: ['security-menu.component.scss'],
  templateUrl: 'security-menu.component.html',
})
export class SecurityMenuComponent {
  private subs: Subscription = new Subscription();

  constructor(private dialog: MatDialog) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onChangePasswordByPasswordClick() {
    this.dialog.open(ChangePasswordByPasswordDialogComponent, { data: {} });
  }
}
